// Miky Motorsport - persistence profilu (localStorage) s migraci + recovery (M3)
import { DEFAULT_CAR } from './data/cars.js';

const KEY = 'miky_motorsport_profile';
const VERSION = 1;
const START_CREDITS = 5000;

export function defaultProfile() {
  return {
    version: VERSION,
    credits: START_CREDITS,
    xp: 0,
    currentCar: DEFAULT_CAR,
    cars: {
      [DEFAULT_CAR]: { owned: true, upgrades: {}, paint: { color: 0xff5e3a } },
    },
    stats: { races: 0, wins: 0, bestPositions: {} },
    career: { events: {}, championships: {} },
    timeTrials: {}, // "trackId_laps" -> { totalMs, bestLapMs }
    daily: null,    // denni vyzva (J): { date, bestMs, wonToday, streak, lastWonDate }
    settings: {
      assists: { abs: true, tcs: true, stability: true },
      idealLine: false,
      actionCam: false, // naklon/look-ahead kamery dle rizeni (default vyp - muze rusit)
      masterVolume: 0.8,
    },
  };
}

function migrate(p) {
  // budouci migrace dle p.version
  if (!p || typeof p !== 'object') return defaultProfile();
  const d = defaultProfile();
  // doplnit chybejici klice (robustnost proti starym/poskozenym profilum)
  const merged = { ...d, ...p };
  merged.version = VERSION;
  merged.cars = p.cars && typeof p.cars === 'object' ? p.cars : d.cars;
  if (!merged.cars[merged.currentCar]) merged.currentCar = DEFAULT_CAR;
  if (!merged.cars[DEFAULT_CAR]) merged.cars[DEFAULT_CAR] = d.cars[DEFAULT_CAR];
  for (const id in merged.cars) {
    const c = merged.cars[id];
    if (!c.upgrades || typeof c.upgrades !== 'object') c.upgrades = {};
    if (!c.paint || typeof c.paint !== 'object') c.paint = { color: 0xff5e3a };
  }
  merged.stats = p.stats && typeof p.stats === 'object' ? { ...d.stats, ...p.stats } : d.stats;
  merged.career = p.career && typeof p.career === 'object' ? p.career : d.career;
  if (!merged.career.events || typeof merged.career.events !== 'object') merged.career.events = {};
  if (!merged.career.championships || typeof merged.career.championships !== 'object') merged.career.championships = {};
  merged.timeTrials = p.timeTrials && typeof p.timeTrials === 'object' ? p.timeTrials : {};
  merged.daily = p.daily && typeof p.daily === 'object' ? p.daily : null;
  merged.settings = p.settings && typeof p.settings === 'object' ? { ...d.settings, ...p.settings } : d.settings;
  if (!merged.settings.assists || typeof merged.settings.assists !== 'object') merged.settings.assists = { ...d.settings.assists };
  else merged.settings.assists = { ...d.settings.assists, ...merged.settings.assists };
  merged.credits = Number.isFinite(merged.credits) ? merged.credits : START_CREDITS;
  merged.xp = Number.isFinite(merged.xp) ? merged.xp : 0;
  return merged;
}

export function loadProfile() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultProfile();
    const migrated = migrate(JSON.parse(raw));
    // Pokud migrace neco zmenila (doplneni klicu/oprava), uloz hned - jinak by se
    // opraveny profil ulozil az pri pristim save (a do te doby by mohl zustat nekonzistentni).
    if (JSON.stringify(migrated) !== raw) saveProfile(migrated);
    return migrated;
  } catch (err) {
    console.warn('Profil poskozeny/nelze nacist, zakladam novy:', err);
    return defaultProfile();
  }
}

export function saveProfile(profile) {
  try {
    localStorage.setItem(KEY, JSON.stringify(profile));
    return true;
  } catch (err) {
    console.warn('Profil nelze ulozit (quota?):', err);
    return false;
  }
}

export function resetProfile() {
  try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
  return defaultProfile();
}

// Pomocnici nad profilem
export function getCar(profile, id = profile.currentCar) {
  return profile.cars[id] || (profile.cars[id] = { owned: true, upgrades: {}, paint: { color: 0xff5e3a } });
}
